export const homeUrl = `http://${process.env.HOST}${process.env.REACT_APP_BACKEND_HOST_PORT}/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}/`;
export const loginUrl = `${homeUrl}idm/#/login`;
export const oauth2ProviderInterceptorUrl = `${homeUrl}gateway_mX4CISs8`;
export const alreadyLoggedUrl = `${window.location.origin}/auth/already-logged`;
export const newPasswordUrl = `${window.location.origin}/auth/new-password`;
export const localLoginUrl = `${window.location.origin}/auth/login`;
export const authErrorUrl = `${window.location.origin}/auth/auth-error`;

const messageCodeMap = {
    forgotPass: "Εάν η διεύθυνση email σας υπάρχει στη βάση δεδομένων μας, θα λάβετε έναν σύνδεσμο ανάκτησης κωδικού πρόσβασης στη διεύθυνση email με περαιτέρω οδηγίες.",
    invalidOperation: "Η συγκεκριμένη ενέργεια δεν είναι έγκυρη πλέον.",
};

export const generateRandomString = (len) => {
    var result = "";
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < len; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

export const readUrlParams = () => {
    return Object.fromEntries(new URLSearchParams(window.location.hash.replace(/.*\?/, "")).entries());
};

export const resolveMessageCode = (code) => {
    if (messageCodeMap[code]) return messageCodeMap[code];
    else return "";
};